<template>
  <div>
    <v-card
      color="primary"
      dark
      elevation="0"
      rounded="0"
      :class="widget.embedMode ? 'pt-4' : ''"
    >
      <div class="mx-auto" style="max-width: 600px;">
        <div class="d-flex align-center">
          <div
            v-if="widget.data.banner"
            class="pl-5 mr-3 pb-2"
          >
            <v-avatar
              size="60"
              style="border: 0"
            >
              <img
                :src="widget.data.banner"
                style="object-fit: cover"
                class="pa-1"
              >
            </v-avatar>
          </div>
          <div
            v-if="widget.data.name"
            :class="widget.data.banner ? 'pl-0' : 'pl-5'"
            class="pb-2 pr-5"
          >
            <h4
              class="font-weight-bold m-0"
              v-html="widget.data.name"
            ></h4>
          </div>
        </div>
        <div
          v-if="widget.data.title"
          class="px-5 pb-5"
        >
          <h4
            class="font-weight-regular m-0"
            v-html="widget.data.title"
          ></h4>
        </div>
      </div>
    </v-card>
    <h5
      v-if="widget.data.description"
      class="font-weight-regular px-5 mb-2 mt-5 mx-auto"
      style="max-width: 600px;"
      v-html="widget.data.description"
    ></h5>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  computed: {
    widget () {
      return this.$store.state.widget
    }
  }
})
export default class Info extends Vue {}
</script>
